import { render } from "./offcanvas-header.vue?vue&type=template&id=2b3f9f86"
import script from "./offcanvas-header.vue?vue&type=script&lang=js"
export * from "./offcanvas-header.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__